import { Component, ComponentType } from "react";

// When working on this, evaluate to migrate it to a functional component
const withSwallowClick = <P extends object>(WrappedComponent: ComponentType<P>) => {
  class HOC extends Component<P> {
    handleKeyDown = (e: React.KeyboardEvent) => {
      if (e.key === "Enter") {
        e.stopPropagation();
      }
    };

    render() {
      return (
        <span onClick={(e) => e.stopPropagation()} onKeyDown={this.handleKeyDown} role="button" tabIndex={0}>
          <WrappedComponent {...this.props} />
        </span>
      );
    }
  }

  return HOC;
};

export default withSwallowClick;
